import { render, staticRenderFns } from "./AutorizationMain.vue?vue&type=template&id=4f2c69ee&scoped=true&"
import script from "./AutorizationMain.vue?vue&type=script&lang=js&"
export * from "./AutorizationMain.vue?vue&type=script&lang=js&"
import style0 from "./AutorizationMain.vue?vue&type=style&index=0&id=4f2c69ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2c69ee",
  null
  
)

export default component.exports